import InvoicingReport from '../sections/invoicing-report';
import PermissionGuard from '../components/auth/PermissionGuard';
import { permissions } from '../config/permissions';

const InvoicingReportPage = () => {
  return (
    <PermissionGuard permissions={[permissions.VIEW_REPORTS]}>
      <InvoicingReport />
    </PermissionGuard>
  );
};

export default InvoicingReportPage;
